import {
  Box,
  Heading,
  HStack,
  Text,
  Link,
  Spacer,
  Icon,
  useColorModeValue,
  Center,
  useMediaQuery,
  IconButton,
  useColorMode,
  DarkMode,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  VStack,
} from '@chakra-ui/react';
import { Link as RouterLink, useLocation, useParams } from 'react-router-dom';
import { BsFillCalendarFill, BsFillPeopleFill } from 'react-icons/bs';
import { GiBasketballBasket, GiBasketballJersey } from 'react-icons/gi';
import { IoMdImages } from 'react-icons/io';
import { AiFillHome } from 'react-icons/ai';

import { RiTeamFill } from 'react-icons/ri';
import { useEventContext } from '../../contexts/EventContext';
import { IconType } from 'react-icons';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';
import { canPerformAction } from '../../contexts/AuthContext/AuthContext';
import { useAppSelector } from '../../app/store';

const DefaultLinkItems: LinkItemProps[] = [
  {
    name: 'Landing',
    to: '/',
    icon: AiFillHome,
  },
];

const EventLinkItems: LinkItemProps[] = [
  {
    name: 'Event Home',
    to: '',
    icon: AiFillHome,
    requiresRole: 'EVENT_ADMIN',
  },
  {
    name: 'Schedule',
    icon: BsFillCalendarFill,
    to: `/schedule`,
  },
  {
    name: 'Teams',
    icon: BsFillPeopleFill,
    to: `/teams`,
    requiresRole: 'LEAGUE_ADMIN',
  },
  {
    name: 'Players',
    icon: GiBasketballJersey,
    to: `/players`,
    requiresRole: 'LEAGUE_ADMIN',
  },
  {
    name: 'Leagues',
    icon: RiTeamFill,
    to: '/leagues',
    requiresRole: 'LEAGUE_ADMIN',
  },
  {
    name: 'Courts',
    icon: (props) => GiBasketballBasket({ ...props, size: 20 }),
    to: `/courts`,
    requiresRole: 'LEAGUE_ADMIN',
  },
  {
    name: 'Feed',
    icon: IoMdImages,
    to: `/feed`,
    requiresRole: 'EVENT_ADMIN',
  },
];

interface LinkItemProps {
  name: string;
  to: string;
  icon: IconType;
  requiresRole?: string;
}

export const EventLinks: React.FC<{
  eventId?: number;
  links: LinkItemProps[];
}> = ({ links, eventId }) => {
  const { eventId: paramEventId } = useParams();
  let eventIdToUse = eventId ?? paramEventId;
  const { toggleColorMode, colorMode } = useColorMode();
  const [isLargerThan768] = useMediaQuery('(min-width: 768px)');

  const baseColor = useColorModeValue('orange', 'blue');

  const bgColor = useColorModeValue('blackAlpha.200', 'whiteAlpha.300');
  return (
    <>
      {links.map(({ name, icon, to }) => (
        <Center key={name} h="full">
          <Link
            h="full"
            key={name}
            _hover={{}}
            as={RouterLink}
            to={`/events/${eventIdToUse}${to}`}
          >
            <HStack
              h="100%"
              p={1}
              color="white"
              _hover={{ background: bgColor }}
              borderRadius="sm"
            >
              {isLargerThan768 ? (
                <>
                  <Icon as={icon}></Icon>
                  <Text size="xl">{name}</Text>
                </>
              ) : (
                <DarkMode>
                  <IconButton icon={icon({})} aria-label={'icon'} />
                </DarkMode>
              )}
            </HStack>
          </Link>
        </Center>
      ))}
      <Center key="mode-switcher-button" h="full">
        <DarkMode>
          <IconButton
            icon={colorMode === 'dark' ? <SunIcon /> : <MoonIcon />}
            aria-label={'color mode switcher'}
            onClick={toggleColorMode}
          />
        </DarkMode>
      </Center>
    </>
  );
};

export const NavBar: React.FC = ({ children }) => {
  const { currentEvent } = useEventContext();
  const userStore = useAppSelector((store) => store.user);
  const baseColor = useColorModeValue('orange', 'blue');
  const location = useLocation();
  const paths = location.pathname
    .split('/')
    .filter((path) => ![''].includes(path));

  return (
    <Box minH="100vh" bg={useColorModeValue('white', 'gray.800')}>
      <Box
        bg={`${baseColor}.500`}
        borderBottom="1px"
        borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
        h={16}
        px={4}
        w="full"
      >
        <HStack spacing={{ base: 1, md: 2 }} h="100%" justify="space-around">
          <HStack>
            <Heading color={'white'} noOfLines={1}>
              Yogi Cup
            </Heading>

            {/* {paths.length > 1 && (
              <Breadcrumb
                fontSize="sm"
                marginTop="0 !important"
                py={0}
                noOfLines={1}
              >
                {paths.map((path, index, paths) => (
                  <BreadcrumbItem key={path}>
                    <BreadcrumbLink
                      as={Link}
                      to={
                        path === 'events'
                          ? '/'
                          : `/${paths.slice(0, index + 1).join('/')}`
                      }
                    >
                      {path.charAt(0).toUpperCase() + path.slice(1)}
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                ))}
              </Breadcrumb>
            )} */}
          </HStack>
          <Spacer />
          <EventLinks
            eventId={currentEvent?.id}
            links={
              currentEvent
                ? EventLinkItems.filter((link) =>
                    canPerformAction(
                      userStore.user?.role,
                      link.requiresRole || 'USER'
                    )
                  )
                : DefaultLinkItems
            }
          />
        </HStack>
      </Box>
      <Box p={2}>{children}</Box>
    </Box>
  );
};
